import { Component } from 'react';

import { Exception, GeneralErrors, cleanStack, createException, useSite } from '@labradorsports/utils';

import { useLogger } from '../../shared/providers/index.js';
import { CrashPage } from '../index.js';

class ErrorBoundaryComponent extends Component<any, any> {
    state: any = {};

    componentDidCatch(error: any, info: any) {
        const finalException =
            error instanceof Exception
                ? error
                : createException(GeneralErrors.UNKNOWN_ERROR, {
                      nestedError: error,
                  });

        this.props.logger.log(cleanStack(info.componentStack, this.props.env.baseUrl));
        this.props.logger.exception(finalException);

        if (typeof this.props.onCatch === 'function') {
            this.props.onCatch();
        }

        this.setState({
            error: finalException,
        });
    }

    render() {
        const { children } = this.props;
        const { error } = this.state;

        if (error) return <CrashPage error={error} />;

        return children;
    }
}

interface Props {
    onCatch?: () => any;
}

const ErrorBoundary: FC<Props> = (props) => {
    const { env } = useSite();
    const logger = useLogger();

    return <ErrorBoundaryComponent {...props} logger={logger} env={env} />;
};

export default ErrorBoundary;
